<template lang="pug">
.inherited-input
  .input-part
    slot
  .switch-part
    label Default
    InheritSwitch(:value="value" @input="val => $emit('input', val)" :disabled="readonly")
</template>

<script>
import InheritSwitch from '@v/settings/application/advanced/InheritSwitch.vue'

export default {
  components: { InheritSwitch },
  props: {
    value: Boolean,
    readonly: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped lang="stylus">
.inherited-input
  width 100%
  display flex

.input-part
  flex-grow 1

.switch-part
  width 100px
  text-align center
  flex-shrink 0

  label
    margin-bottom 16px
    width 100%
    text-align center
</style>
